import React from "react";

// A branded stand-in for tournament photography: court lines over a gradient
// whose hue is derived from the tournament name, so every event looks distinct
// without shipping the same stock photo twelve times (design system §16).
//
// Replace with real event photography before launch — this is a placeholder
// that looks deliberate, not a design choice.
const hueFrom = (seed = "") => {
  let hash = 0;
  for (let i = 0; i < seed.length; i++) {
    hash = (hash * 31 + seed.charCodeAt(i)) % 360;
  }
  // Keep to the cool half of the wheel so it stays on-brand next to the navy.
  return 190 + (hash % 80);
};

const CourtArt = ({ seed = "", label, className = "" }) => {
  const hue = hueFrom(seed);

  return (
    <div
      className={`relative flex h-full w-full items-center justify-center overflow-hidden ${className}`}
      style={{
        background: `linear-gradient(135deg, hsl(${hue} 70% 32%), hsl(${
          hue + 25
        } 65% 18%))`,
      }}
      aria-hidden="true"
    >
      <svg
        className="absolute inset-0 h-full w-full text-white/20"
        viewBox="0 0 320 180"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        preserveAspectRatio="xMidYMid slice"
      >
        {/* Court outline, service boxes and net line. */}
        <rect x="40" y="24" width="240" height="132" />
        <path d="M160 24v132M40 90h240M92 24v132M228 24v132" />
        <circle cx="278" cy="34" r="40" className="text-white/10" />
      </svg>
      {label && (
        <span className="relative px-4 text-center text-sm font-semibold uppercase tracking-widest text-white/80">
          {label}
        </span>
      )}
    </div>
  );
};

export default CourtArt;
